/**
 * Пояснение светофора раздела «Экология» (макет варианта Б): что значит каждый цвет и когда строка
 * становится «Истекает» / «Скоро срок» — пороги из настроек раздела (задаёт администратор).
 */
import type { EcoSettings, EcoStatusColor } from '@/lib/api'
import { pluralRu } from '@/lib/orders'
import { StatusDot } from '@/design-system/components/primitives/status-dot'

const LEGEND: { color: EcoStatusColor; label: string; meaning: string }[] = [
  { color: 'green', label: 'зелёный', meaning: 'действует / сдано / ведётся' },
  { color: 'amber', label: 'жёлтый', meaning: 'истекает / скоро срок / требует актуализации' },
  { color: 'red', label: 'красный', meaning: 'просрочено / отсутствует' },
  { color: 'gray', label: 'серый', meaning: 'не требуется' },
]

const days = (n: number) => `${n} ${pluralRu(n, 'день', 'дня', 'дней')}`

export function EcoStatusLegend({ settings }: { settings: EcoSettings | null }) {
  return (
    <div className="mt-4 text-12 leading-relaxed text-txt-secondary">
      <span className="mr-1">Цвет — по сроку:</span>
      {LEGEND.map((l, i) => (
        <span key={l.color}>
          <span className="whitespace-nowrap">
            <StatusDot variant={l.color} label={l.label} aria-hidden className="mx-1" />
            <span className="font-medium text-txt">{l.label}</span>
          </span>{' '}
          — {l.meaning}
          {i < LEGEND.length - 1 ? ' · ' : '. '}
        </span>
      ))}
      {settings ? (
        <span>
          «Истекает» и «Скоро срок» — за {days(settings.expiringDays)} до срока (ежеквартальная
          отчётность — за {days(settings.expiringDaysQuarterly)}, ежемесячная — за{' '}
          {days(settings.expiringDaysMonthly)}).
        </span>
      ) : null}
    </div>
  )
}
